var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray-700 w-full px-4 py-4"},[_c('div',{staticClass:"text-white font-semibold"},[_vm._v(" Winston © 2021 ")])])}]

export { render, staticRenderFns }